import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/admin/login"); return; }
    const session_id = decodeURIComponent(match[1]);
    api.post("/auth/google/callback", { session_id })
      .then(() => navigate("/admin/dashboard", { replace: true }))
      .catch(() => navigate("/admin/login?error=google"));
  }, [navigate]);

  return <div className="py-32 text-center text-[#8C7A6B]">Signing you in…</div>;
}
